module.exports = __webpack_public_path__ + "img/detail_praise@2x.707316d7.png";